import React, { useState, useEffect } from "react";

import * as R from "ramda";
import { useLocation } from "react-router-dom";

import { Toastr } from "clearsense-ui/components";

import Search from "./Search";

import Results from "../Results";

const NPIRegistry = () => {
  const [searchParams, setSearchParams] = useState({});
  const location = useLocation();

  useEffect(() => {
    setSearchParams({});
  }, [location.key]);

  const handleSubmit = (values, { setSubmitting }) => {
    const formattedValues = {
      ...values,
      entityTypeCode: values.entityTypeCode.value,
      addressType: values.addressType.value,
      state: values.state.value,
      countryCode: values.countryCode.value,
    };

    const isEmptySearch = Object.values(
      R.omit(["addressType", "exactMatch"], formattedValues)
    ).every(val => R.isEmpty(val));

    if (isEmptySearch) {
      Toastr.error("Search fields can't be empty.");
    } else {
      setSearchParams(formattedValues);
    }
    setSubmitting(false);
  };

  return (
    <>
      {R.isEmpty(searchParams) ? (
        <Search handleSubmit={handleSubmit} />
      ) : (
        <Results
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      )}
    </>
  );
};

export default NPIRegistry;
